export default function anonymizeIp(ip) {
  if (!ip) return ip;
  if (ip.includes(':')) {
    const full = ip.split(':');
    return full.slice(0, 3).concat(Array(5).fill('0000')).join(':');
  }
  const parts = ip.split('.');
  parts[3] = '0';
  return parts.join('.');
}
